var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLightbulbFilled = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.996 14c-.33 0-.613-.117-.846-.352a1.16 1.16 0 01-.35-.848h2.4c0 .333-.118.617-.354.85-.235.233-.519.35-.85.35zM5.6 12v-1.2h4.8V12H5.6zm-.25-2a4.284 4.284 0 01-1.592-1.708A4.901 4.901 0 013.2 6c0-1.333.467-2.467 1.4-3.4.933-.933 2.067-1.4 3.4-1.4 1.333 0 2.467.467 3.4 1.4.933.933 1.4 2.067 1.4 3.4 0 .811-.186 1.575-.558 2.292A4.284 4.284 0 0110.65 10h-5.3zm.383-1.2h4.534c.422-.344.75-.761.983-1.25.233-.489.35-1.006.35-1.55 0-1.004-.349-1.855-1.046-2.553C9.856 2.75 9.006 2.4 8.004 2.4 7 2.4 6.15 2.75 5.45 3.447 4.75 4.145 4.4 4.997 4.4 6c0 .544.117 1.061.35 1.55.233.489.561.906.983 1.25z",
    fill: "#164C50"
  })));
};
export default SvgLightbulbFilled;